import { createApiSlice } from "@common";
import {
  CURD_ACCOUNT_MANAGER
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addAccountManager",
    method: "post",
    url: CURD_ACCOUNT_MANAGER,
    stateKey: "message",
  },
  {
    name: "getAccountManager",
    method: "get",
    url: CURD_ACCOUNT_MANAGER,
    stateKey: "data",
  },
  {
    name: "updateAccountManager",
    method: "put",
    url: CURD_ACCOUNT_MANAGER,
    stateKey: "message",
  },
  {
    name: "deleteAccountManager",
    method: "delete",
    url: CURD_ACCOUNT_MANAGER,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "accountManager",
  apiConfig,
  customReducers,
);
const accountManagerSlice = slice;
// Export the slice's reducer
export default accountManagerSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addAccountManager,
  getAccountManager,
  updateAccountManager,
  deleteAccountManager
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
